import React from 'react';
import Addwarehouse from './Addwarehouse';

export default function Fulfillment() {
    return <Addwarehouse initialTab="3" />;
}
